import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const contentHealthDataSchema = z.object({
  challenges: z.object({
    total: z.number(),
    published: z.number(),
    draft: z.number(),
    inTriage: z.number(),
  }),
  clips: z.object({
    total: z.number(),
    published: z.number(),
    pendingTriage: z.number(),
    approved: z.number(),
    rejected: z.number(),
  }),
  translations: z.object({
    byLang: z.array(z.object({ lang: z.string(), count: z.number() })),
    totalChallenges: z.number(),
  }),
  collectionsNeedingTriage: z.array(
    z.object({
      collectionId: z.number().nullable(),
      title: z.string(),
      pendingCount: z.number(),
    }),
  ),
});

export type IGetContentHealthData = z.infer<typeof contentHealthDataSchema>;

export const getContentHealthResponseSchema = createApiResponseSchema(
  contentHealthDataSchema,
) as z.ZodSchema<IAPI<IGetContentHealthData>>;

export type IGetContentHealthResponse = IAPI<IGetContentHealthData>;
